import toast from 'cogo-toast'
import { string, object } from 'yup'

import { t } from '@lingui/macro'

export const submit = (mutate, collectionId, i18n) =>
  function (input) {
    mutate({ variables: { input: { collectionId, ...input } } }).then(() => {
      toast.success(t(i18n)`Messaggio inviato`)
    })
  }

export const validationSchema = object().shape({
  email: string().email().required(),
  message: string().min(3).required(),
  name: string().min(3).required(),
})
